import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingButton } from "@mui/lab";

const BottomBarButton = styled(LoadingButton)(() => ({
    "& .MuiButton-startIcon": {
        marginRight: "5px !important",
        marginLeft: "3px !important",
    },
    "& .MuiLoadingButton-loadingIndicator": {
        left: "5px !important",
    },
}));

function PTMBottomAppBar(props) {
    const { buttons, infoText } = props;
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            // alignItems: "center",
        }}
        >
            {infoText}
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                width: "100%",
                padding: "10px 5px",
            }}
            >
                {
                    buttons?.map((button) => (
                        !button.hide
                    && (
                        button.file ? (
                            <Button
                                key={button.name}
                                sx={{
                                    "&:not(:last-child)": {
                                        marginRight: "5px",
                                    },
                                    MuiButton: {
                                        display: "none !important",
                                    },
                                    textTransform: "none",
                                    fontSize: "12px",
                                }}
                                startIcon={(
                                    <FontAwesomeIcon
                                        style={{
                                            fontSize: "14px !important",
                                            marginRight: "0px !important",
                                        }}
                                        icon={button?.icon}
                                        {...button?.animate && { ...button.animate }}
                                    />
                                )}
                                color={button?.color}
                                variant="contained"
                                component="label"
                            >
                                {button?.name}
                                <input
                                    onInput={button.onInput}
                                    style={{ display: "none" }}
                                    accept={button?.accept}
                                    type={button?.type}
                                    multiple={button?.multiple}
                                />
                            </Button>
                        ) : (
                            <BottomBarButton
                                key={button.name}
                                sx={{
                                    "&:not(:last-child)": {
                                        marginRight: "5px",
                                    },
                                    MuiButton: {
                                        display: "none !important",
                                    },
                                    textTransform: "none",
                                    fontSize: "12px",
                                }}
                                size="small"
                                onClick={button.click}
                                variant="contained"
                                startIcon={(
                                    <FontAwesomeIcon
                                        style={{
                                            fontSize: "14px !important",
                                            marginRight: "0px !important",
                                        }}
                                        icon={button?.icon}
                                        {...button?.animate && { ...button.animate }}
                                    />
                                )}
                                color={button?.color}
                                disabled={button?.disabled}
                                hide={button?.hide}
                                loading={button?.loading}
                                loadingPosition="start"
                                ref={button.ref}
                            >
                                {button?.name}
                            </BottomBarButton>
                        ))
                    ))
                }
            </div>
        </div>
    );
}

export default PTMBottomAppBar;
